RivalIQ.module('views', function (views, App, Backbone, Marionette, $, _) {

    'use strict';

    views.TableRow = Marionette.CollectionView.extend({
        events: {
            click: 'onClick',
            mouseover: 'onHover'
        },
        tagName: 'tr',
        getChildView: function (model) {
            const me = this;
            if (me.options.isHeader && model.get('headerView')) {
                return model.get('headerView');
            } else if (model.get('cellView')) {
                return model.get('cellView');
            }

            return views.TableColumn;
        },
        childViewOptions: function () {
            const me = this;

            return {
                isHeader: Boolean(me.isHeader)
            };
        },
        initialize: function (options) {
            const me = this;
            const opts = options || {};
            me.collection = me.getColumnCollection(opts);
            _.extend(me, _.pick(opts, 'isHeader'));
        },
        onRender: function () {
            const me = this;
            const rowClass = me.model.get('rowClass');
            if (rowClass) {
                me.$el.addClass(rowClass);
            }
        },

        onHover: function (e) {
            const me = this;
            const onHover = me.model.get('onHover');

            if (_.isFunction(onHover)) {
                return onHover(e);
            }
        },

        onClick: function (e) {
            const me = this;
            const onClick = me.model.get('onClick');

            if (_.isFunction(onClick)) {
                return onClick(e);
            }
        },
        getColumnCollection: function (config) {
            let columns = null;

            if (config.columns) {
                columns = config.columns;
            } else if (config.model && config.model.has('columns')) {
                columns = config.model.get('columns');
            }

            return new Backbone.Collection(columns || []);
        }
    });

});
